import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { InvoicesService } from 'src/app/services/invoices.service';

export interface DialogData {
    invoice: InvoiceInterface
    refund: boolean
}

@Component({
  selector: 'app-dialog-record-payment',
  templateUrl: 'record-payment.dialog.html',
  styleUrls: ['./record-payment.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecordPaymentDialogComponent {
  date = new FormControl(new Date());
  amount: number = 0;
  refund: boolean = false;

  invoice: InvoiceInterface;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<RecordPaymentDialogComponent>,
    public dialog: MatDialog,
    private invoiceService: InvoicesService
    ) {
        this.invoice = this.invoiceService.validate(this.data.invoice);

        this.amount = this.invoice.amountDue;

        if (this.data.refund) {
          this.refund = this.data.refund;
        }
    }

  ngOnInit() {

  }

  submit(method: string) {
  
    let type = "Payment";
    if (this.refund) {
      type = "Refund";
    }
    console.log(this.amount)

    this.invoice.paymentsMade.push({
        amount: this.amount,
        date: this.date.value,
        method: method,
        note: "",
        paymentId: `pay-${Date.now()}`,
        transactionSha1: null
    });

    console.log(this.invoice.paymentsMade)

    this.invoiceService.updateOne(this.invoice).subscribe(r => {
        this.dialogRef.close(r || this.invoice);
    });
  }
}
